import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loginModal", "registerModal", "modalAlert"]

  connect() {
    this._handleKeydown = this._handleKeydown.bind(this)
    this._dismissTimer = null
  }

  modalAlertTargetConnected(element) {
    this._scheduleDismiss(element)
  }

  openLogin() {
    this._closeAll()
    this._clearErrors("login-error")
    this._show(this.loginModalTarget)
  }

  openRegister() {
    this._closeAll()
    this._clearErrors("register-error")
    this._show(this.registerModalTarget)
  }

  close() {
    this._closeAll()
  }

  backdropClick(event) {
    if (event.target === event.currentTarget) {
      this._closeAll()
    }
  }

  _show(target) {
    target.classList.remove("hidden")
    document.addEventListener("keydown", this._handleKeydown)
    document.body.style.overflow = "hidden"
  }

  _closeAll() {
    if (this.hasLoginModalTarget) {
      this.loginModalTarget.classList.add("hidden")
    }
    if (this.hasRegisterModalTarget) {
      this.registerModalTarget.classList.add("hidden")
    }
    document.removeEventListener("keydown", this._handleKeydown)
    document.body.style.overflow = ""
  }

  _handleKeydown(event) {
    if (event.key === "Escape") {
      this._closeAll()
    }
  }

  _clearErrors(containerId) {
    if (this._dismissTimer) {
      clearTimeout(this._dismissTimer)
      this._dismissTimer = null
    }
    const container = document.getElementById(containerId)
    if (container) {
      container.innerHTML = ""
      container.className = ""
      container.id = containerId
    }
  }

  _scheduleDismiss(element) {
    if (this._dismissTimer) clearTimeout(this._dismissTimer)
    this._dismissTimer = setTimeout(() => {
      element.classList.add("fade-out")
      setTimeout(() => {
        element.innerHTML = ""
        element.className = ""
      }, 400)
    }, 5000)
  }
}
